import { State as VehiclesDetailsState } from '../reducers/vehicles-details-reducer';
import { Selector } from '@ngrx/store';
export const getHasSuccess: Selector<VehiclesDetailsState, boolean> = (state: VehiclesDetailsState) => state.hasSuccess;
export const getHasError: Selector<VehiclesDetailsState, boolean> = (state: VehiclesDetailsState) => state.hasError;
export const getIsLoading: Selector<VehiclesDetailsState, boolean> = (state: VehiclesDetailsState) => state.isLoading;
export const getMessage: Selector<VehiclesDetailsState, string | null> = (state: VehiclesDetailsState) => state.message;
